import { render, staticRenderFns } from "./measurements-general-container.vue?vue&type=template&id=682f1340&scoped=true&"
import script from "./measurements-general-container.vue?vue&type=script&lang=ts&"
export * from "./measurements-general-container.vue?vue&type=script&lang=ts&"
import style0 from "./measurements-general-container.vue?vue&type=style&index=0&id=682f1340&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682f1340",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCarousel } from 'vuetify/lib/components/VCarousel';
import { VCarouselItem } from 'vuetify/lib/components/VCarousel';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCarousel,VCarouselItem,VCol,VRow})
